import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { fetchDownloadLinks, DownloadBook } from "../redux/actions";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: 752,
  },
  demo: {
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    margin: theme.spacing(4, 0, 2),
  },
  circularProgress: {
    display: "flex",
    "& > * + *": {
      marginLeft: theme.spacing(2),
    },
  },
}));

export default function DownloadDialogue(props) {
  const [open] = React.useState(true);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();
  const [dense] = React.useState(false);

  const downloadLinks = useSelector((state) => {
    const bookId = props.bookId;

    if (state.downloadLinks && state.downloadLinks[bookId]) {
      return state.downloadLinks[bookId].books;
    } else {
      return [];
    }
  });

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(
      fetchDownloadLinks(
        props.title,
        props.authors ? props.authors[0] : "",
        props.bookId
      )
    );
  }, [props.bookId, props.authors, props.title, dispatch]);

  const handleClose = () => {
    props.closeDownloadLinksDialogue();
  };

  const renderDownloadLinksList = () => {
    if (downloadLinks.length > 0) {
      return downloadLinks.map((item) => {
        return (
          <ListItem key={item.id}>
            <ListItemText primary={item.name} secondary={item.author} />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                aria-label="delete"
                onClick={() => dispatch(DownloadBook(item.id))}
              >
                <CloudDownloadIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        );
      });
    } else {
      return null;
    }
  };

  const renderDialogueContent = () => {
    if (downloadLinks.length === 0) {
      return (
        <div className={classes.circularProgress}>
          <CircularProgress color="secondary" style={{ margin: "auto" }} />
        </div>
      );
    } else {
      return (
        <div className={classes.demo}>
          <List dense={dense}>{renderDownloadLinksList()}</List>
        </div>
      );
    }
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">{"Download:"}</DialogTitle>
        <DialogContent>{renderDialogueContent()}</DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
